import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowListItemSecondaryAction: Components<Theme>['MuiListItemSecondaryAction'] = {
  defaultProps: {},
  styleOverrides: {
    // IconButton in <ListItem secondaryAction={...} />
    root: {
      // no longer absolute position as we are using flex
      position: 'static',
      transform: 'none',
    },
  },
};
